var _rect, _rect2, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0004 27.75C18.5904 27.75 18.2504 27.41 18.2504 27V22.81L17.5304 23.53C17.2404 23.82 16.7604 23.82 16.4704 23.53C16.1804 23.24 16.1804 22.76 16.4704 22.47L18.4704 20.47C18.6804 20.26 19.0104 20.19 19.2904 20.31C19.5704 20.42 19.7504 20.7 19.7504 21V27C19.7504 27.41 19.4104 27.75 19.0004 27.75Z",
    fill: "url(#paint0_linear_1_303)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0004 23.7499C20.8104 23.7499 20.6204 23.6799 20.4704 23.5299L18.4704 21.5299C18.1804 21.2399 18.1804 20.7599 18.4704 20.4699C18.7604 20.1799 19.2404 20.1799 19.5304 20.4699L21.5304 22.4699C21.8204 22.7599 21.8204 23.2399 21.5304 23.5299C21.3804 23.6799 21.1904 23.7499 21.0004 23.7499Z",
    fill: "url(#paint1_linear_1_303)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 32.75H19C13.57 32.75 11.25 30.43 11.25 25V19C11.25 13.57 13.57 11.25 19 11.25H24C24.41 11.25 24.75 11.59 24.75 12C24.75 12.41 24.41 12.75 24 12.75H19C14.39 12.75 12.75 14.39 12.75 19V25C12.75 29.61 14.39 31.25 19 31.25H25C29.61 31.25 31.25 29.61 31.25 25V20C31.25 19.59 31.59 19.25 32 19.25C32.41 19.25 32.75 19.59 32.75 20V25C32.75 30.43 30.43 32.75 25 32.75Z",
    fill: "url(#paint2_linear_1_303)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 20.75H28C24.58 20.75 23.25 19.42 23.25 16V12C23.25 11.7 23.43 11.42 23.71 11.31C23.99 11.19 24.31 11.26 24.53 11.47L32.53 19.47C32.74 19.68 32.81 20.01 32.69 20.29C32.57 20.57 32.3 20.75 32 20.75ZM24.75 13.81V16C24.75 18.58 25.42 19.25 28 19.25H30.19L24.75 13.81Z",
    fill: "url(#paint3_linear_1_303)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_303",
    x1: 18.0017,
    y1: 20.2515,
    x2: 18.0017,
    y2: 27.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A674A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C3D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_303",
    x1: 20.0004,
    y1: 20.2524,
    x2: 20.0004,
    y2: 23.7499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A674A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C3D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_303",
    x1: 22,
    y1: 11.25,
    x2: 22,
    y2: 32.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A674A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C3D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_303",
    x1: 27.9993,
    y1: 11.2515,
    x2: 27.9993,
    y2: 20.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A674A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C3D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.7d985ba1a066c34e905e22385f236289.svg";
export { ForwardRef as ReactComponent };